import { EyeOutlined } from "@ant-design/icons";
import { Button, Table } from "antd";
import { useTranslation } from "react-i18next";
import { getTableRowNumber } from "../utils/tablePagination";

const TicketsTable = ({ tickets, loading, paginationData }) => {
  const { t } = useTranslation();

  const TicketsTableColumns = [
    {
      title: "#",
      key: "index",
      className: "app-table-index-column",
      render: (text, record, index) => {
        return <p>{getTableRowNumber(index, paginationData)}</p>;
      },
    },
    {
      title: t("description"),
      dataIndex: "description",
    },
    {
      title: t("attachment"),
      dataIndex: "attachment",
      width: "200px",
      render: (attachment) => {
        return (
          <>
            <div>
              {attachment ? (
                <Button
                  type="primary"
                  href={attachment}
                  size="small"
                  target="_blank"
                >
                  <EyeOutlined /> {t("preview") + " " + t("attachment")}
                </Button>
              ) : (
                <div>{t("no_attachment")}</div>
              )}
            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Table
        columns={TicketsTableColumns}
        dataSource={tickets}
        loading={loading}
        rowKey="id"
        pagination={false}
      />
    </>
  );
};

export default TicketsTable;
